export const SET_LOADED = 'APP/SET_LOADED';
